// Global debug flags
export const DEBUG = {
	COLLISION: false, // Show collision boxes and debug visuals
};
